import getTotalListings from './getTotalListings';

type ListingCountPaginationSummaryArgs = {
  key: string;
  interpolationOptions: {
    count?: number;
    from?: number;
    to?: number;
    total?: string;
  };
};

type PaginationData = {
  /**
   * The total number of results.
   */
  count: number;
  /**
   * The number of result per page.
   */
  limit: number;
  /**
   * The page number.
   */
  page?: number;
  /**
   * Should the count be round to the nearest 100 or 1000?
   * Defaults to false.
   */
  rounded?: boolean;
  isNavUpdateEnabled?: boolean;
};

const getListingCountPaginationSummary = ({
  count,
  limit,
  page,
  rounded = false,
  isNavUpdateEnabled = false,
}: PaginationData): ListingCountPaginationSummaryArgs => {
  if (count <= limit) {
    return {
      key: isNavUpdateEnabled
        ? 'new-listing-count-pagination-summary--listing-count'
        : 'listing-count-pagination-summary--listing-count',
      interpolationOptions: { count },
    };
  }

  const from = page || 1;
  const totalPages = Math.ceil(count / limit);
  const to = totalPages;
  const total = getTotalListings(count, rounded);

  return {
    key: isNavUpdateEnabled
      ? 'listing-count-pagination-summary--pagination-summary-new'
      : 'listing-count-pagination-summary--pagination-summary',
    interpolationOptions: { from, to, total },
  };
};

export default getListingCountPaginationSummary;
